import React from "react";
import FilterGroup from "../../common/reports/FilterGroup";
import FilterItem from "../../common/reports/FilterItem";
import Button from "../../framework/Button";
import Shortcut from "../../framework/Shortcut";
import classes from "./EntityReportSummary.module.css";

const EntityReportSummary = ({
  showAutoComplete = () => {},
  showCustomerCategoryAutoComplete = () => {},
  refreshData = () => {},
  refreshRef,
}) => {
  // const { addRef } = useContext(ProductsContext);
  return (
    <div className={classes["summary-container"]}>
      <div className={classes["summary-ctas"]}>
        <FilterGroup>
          <FilterItem>
            <Button
              ref={refreshRef}
              label="Refresh"
              color="black"
              onClick={() => {
                refreshData();
              }}
              endIcon={<Shortcut keys={["Alt", "R"]} />}
            />
          </FilterItem>
          <FilterItem>
            <Button
              // ref={addRef}
              label="Add New Entity"
              color="violet"
              onClick={showAutoComplete}
              endIcon={<Shortcut keys={["Alt", "E"]} />}
            />
          </FilterItem>
          {/* <FilterItem>
            <Button
              label="Add/Edit Entity Category"
              color="violet"
              onClick={showCustomerCategoryAutoComplete}
              endIcon={<Shortcut keys={["Alt", "C"]} />}
            />
          </FilterItem> */}
        </FilterGroup>
      </div>
    </div>
  );
};

export default EntityReportSummary;
